export class DocumentUploadUrlResponse {
  fileName: string;
  uploadUrl: string;
  downloadUrl: string;

  constructor(opts: DocumentUploadUrlResponse) {
    this.fileName = opts.fileName;
    this.uploadUrl = opts.uploadUrl;
    this.downloadUrl = opts.downloadUrl;
  }
}
